<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><a id="dedication"></a><em>For Laura</em></p>
<p class="dedication"><em>“e come sare ‘ io sanza te corso?</em></p>
<p class="dedication"><em>chi m’avria tratto su per la montagna?”</em></p>
<p class="dedication"><em>(adapted from</em> Purgatorio <em>111:5–6)</em></p>
<p class="dedication"><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?273a4026